import { useAccountId } from 'ContextProviders/CurrentAccount'
import { AccountType } from 'core/types'
import { type AttendanceAccountContext } from 'Pages/Attendance/types'

export function useAttendanceAccountContext (): AttendanceAccountContext {
  const activeAccount = useAccountId()

  if (activeAccount == null || (activeAccount.id === 0 && activeAccount.type !== AccountType.Admin)) {
    return {
      ready: false,
      scopeLabel: 'Select an account'
    }
  }

  const scopeLabel = activeAccount.type === AccountType.SERVICE_PROVIDER
    ? 'Service provider'
    : activeAccount.type === AccountType.ISD
      ? 'ISD'
      : activeAccount.type === AccountType.Admin
        ? 'All ISDs'
        : 'Intake'

  return {
    accountId: activeAccount.id,
    accountType: activeAccount.type,
    currentISDID: activeAccount.currentISDID,
    ready: true,
    scopeLabel
  }
}
